import { render, staticRenderFns } from "./icon-search-collapse.vue?vue&type=template&id=3510da63&"
import script from "./icon-search-collapse.vue?vue&type=script&lang=js&"
export * from "./icon-search-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports